// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5025) return "static/chunks/5025-73582c4eb5262b56.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "d7d49d8f3d323fca" + ".js";
};